module.exports = __webpack_public_path__ + "static/img/IMG_20170720_004721.3426a993.jpg";